export const STRINGS = {
  FREE_TRIAL_MESSAGE:
    "Your account is on free trial. Your trial period will end on",
  ADD_CARD_DETAILS: "ADD CARD DETAILS"
};
